var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.75 104.583V83.6666C62.75 49.0495 73.2083 20.9166 125.5 20.9166C177.792 20.9166 188.25 49.0495 188.25 83.6666V104.583",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 193.479C139.94 193.479 151.646 181.773 151.646 167.333C151.646 152.893 139.94 141.188 125.5 141.188C111.06 141.188 99.3542 152.893 99.3542 167.333C99.3542 181.773 111.06 193.479 125.5 193.479Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.792 230.083H73.2084C31.3751 230.083 20.9167 219.625 20.9167 177.792V156.875C20.9167 115.042 31.3751 104.583 73.2084 104.583H177.792C219.625 104.583 230.083 115.042 230.083 156.875V177.792C230.083 219.625 219.625 230.083 177.792 230.083Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/lockedIcon.6a1860d092b8e8c5bdc32df1d4fecd1a.svg";
export { ForwardRef as ReactComponent };